// extracted by mini-css-extract-plugin
export var closeButton = "videoHighlight-module--closeButton--12251";
export var ctaArrow = "videoHighlight-module--ctaArrow--68a1e";
export var ctaContainer = "videoHighlight-module--ctaContainer--63459";
export var ctaPlayLink = "videoHighlight-module--ctaPlayLink--24d62";
export var headline = "videoHighlight-module--headline--c1db7";
export var inlineReactPlayer = "videoHighlight-module--inlineReactPlayer--237ba";
export var paragraph = "videoHighlight-module--paragraph--d3e3f";
export var thumbnailImage = "videoHighlight-module--thumbnailImage--44424";
export var videoHighlightContainer = "videoHighlight-module--videoHighlightContainer--e606e";
export var videoHighlightLeft = "videoHighlight-module--videoHighlightLeft--2e90e";
export var videoHighlightModalClose = "videoHighlight-module--videoHighlightModalClose--9ab49";
export var videoHighlightModalContent = "videoHighlight-module--videoHighlightModalContent--dc341";
export var videoHighlightModalOverlay = "videoHighlight-module--videoHighlightModalOverlay--eecae";
export var videoHighlightModalVideo = "videoHighlight-module--videoHighlightModalVideo--a06d2";
export var videoHighlightPlayButton = "videoHighlight-module--videoHighlightPlayButton--4681f";
export var videoHighlightPlayIcon = "videoHighlight-module--videoHighlightPlayIcon--6cab6";
export var videoHighlightRight = "videoHighlight-module--videoHighlightRight--ded40";
export var videoHighlightThumbnail = "videoHighlight-module--videoHighlightThumbnail--73f71";